// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__3AqnH","unreadBadge":"styles_unreadBadge__LHT4j","modalContent":"styles_modalContent__2YbUh","modal":"styles_modal__gsZWJ"};